import { render, staticRenderFns } from "./WeServeOrderDetailsModal.vue?vue&type=template&id=e56b4ab8&scoped=true&"
import script from "./WeServeOrderDetailsModal.vue?vue&type=script&lang=js&"
export * from "./WeServeOrderDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./WeServeOrderDetailsModal.vue?vue&type=style&index=0&id=e56b4ab8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56b4ab8",
  null
  
)

export default component.exports